import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import LayoutContainer from "../../../components/LayoutsContainer";
import { AccordionActions, Button, Grid } from "@material-ui/core";
import TitleContainer from "../../LogoLinks/TitleContainer";

import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useHistory } from "react-router-dom";
import PagesTitle from "../../../components/Common/PagesTitle";
import UseMobile from "../../../hooks/useIsMobile";
import HTMLReactParser from "html-react-parser";
import AccordionList from "../../../components/AccordionList";
const useStyles = makeStyles((theme) => ({
  root: {
    padding: "5vh 0vw",
    [theme.breakpoints.down("md")]: {
      padding: "2vh 0vw",
    },
  },
  achievementContainer: {
    marginTop: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(2),
    },
  },
  readmoreBtn: {
    borderRadius: 100,
  },
  heading: {
    fontSize: "1.2rem",
    color: theme.palette.primary.main,
    fontWeight: "bold",
  },
}));

const GramSchemesLayout = ({ data }) => {
  const classes = useStyles();
  const isMobile = UseMobile();

  async function downloadURI(uri, name) {
    let fetchUrl =
      "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf";
    let proxyUrl = "https://api.allorigins.win/get?url=";
    var link = document.createElement("a");
    link.href = proxyUrl + fetchUrl;
    link.download = "name.pdf";
    document.body.appendChild(link);
    link.click();
    // link.dispatchEvent(new MouseEvent("click"));
    document.body.removeChild(link);

    // await fetch(proxyUrl + fetchUrl)
    //   .then((resp) => resp.blob())
    //   .then((blob) => {
    //     const url = window.URL.createObjectURL(blob);
    //     const a = document.createElement("a");
    //     a.style.display = "none";
    //     a.href = url;
    //     // the filename you want
    //     a.download = "todo-1.pdf";
    //     document.body.appendChild(a);
    //     a.click();
    //     window.URL.revokeObjectURL(url);
    //     alert("your file has downloaded!"); // or you know, something with better UX...
    //   })
    //   .catch(() => alert("oh no!"));

    // alert(uri);

    // // let fetchUrl = uri;
    // let fetchUrl =
    //   "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf";
    // let proxyUrl = "https://cors-anywhere.herokuapp.com/";
    // try {
    //   const res = await fetch(proxyUrl + fetchUrl);
    //   console.log("not null", res);
    //   const blob = await res.text();
    //   // const blobUrl = blob.match(
    //   //   new RegExp(firstvariable + "(.*)" + secondvariable)
    //   // )[1];
    //   if (blob !== null) {
    //   alert("not null");

    // } catch (error) {
    //   // console.log("ERROR", m.format(DateFormat), "Data not available");
    // }
    // If you don't know the name or want to use
    // the webserver default set name = ''
  }

  return (
    <div className={classes.root}>
      <LayoutContainer>
        <div>
          <Grid
            container
            direction="column"
            alignItems={isMobile ? "center" : "flex-start"}
          >
            <Grid item className={classes.TitleContainer}>
              <PagesTitle title={data.title} />
            </Grid>
          </Grid>
        </div>
        <div className={classes.achievementContainer}>
          <AccordionList data={data?.data} type="form" />
        </div>
      </LayoutContainer>
    </div>
  );
};
export default GramSchemesLayout;
